import { render, staticRenderFns } from "./ProductDepartment.vue?vue&type=template&id=31a472dd&"
import script from "./ProductDepartment.vue?vue&type=script&lang=js&"
export * from "./ProductDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a472dd')) {
      api.createRecord('31a472dd', component.options)
    } else {
      api.reload('31a472dd', component.options)
    }
    module.hot.accept("./ProductDepartment.vue?vue&type=template&id=31a472dd&", function () {
      api.rerender('31a472dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product-department/ProductDepartment.vue"
export default component.exports